import React, { useState } from 'react';
import PropTypes from "prop-types";

const FiltersContext = React.createContext();

const FiltersProvider = (props) => {
  const [businessUnits, setBusinessUnits] = useState([]);
  const [categories, setCategories] = useState([]);

  const labels = {
    "blh": "BLHN",
    "vpgt": "FS"
  };

  const getFiltersAccordingToRoles = (productsFilters, userRoles) => {
    const businessUnits = Object.keys(productsFilters);
    if (userRoles?.includes('admin'))
      return businessUnits;

    return businessUnits
      .filter(bu => userRoles.includes(`${bu}_edit`) || userRoles.includes(`${bu}_view`));
  };

  const getBusinessUnits = (productsFilters = {}, userRoles) => {
    setBusinessUnits([
      '',
      ...getFiltersAccordingToRoles(productsFilters, userRoles)
    ].map(e => ({ value: e, label: labels[e]??e.toUpperCase() })));
  };

  const getCategories = (businessUnit, filtersSchemes = {}) => {
    setCategories([
      { value: '', label: '' },
      ...(filtersSchemes[businessUnit] || []).map(c => {
        const label = c.label
          .split(' ')
          .map(e => e.slice(0, 1).toUpperCase() + e.slice(1).toLowerCase())
          .join(' ');
        return { value: c.route, label };
      })
    ]);
  };

  return (
    <FiltersContext.Provider
      value={{
        state: { businessUnits, categories },
        actions: { getBusinessUnits, getCategories }
      }}
    >
      {props.children}
    </FiltersContext.Provider>
  );
}

FiltersContext.propTypes = {
  children: PropTypes.element,
};

export { FiltersProvider, FiltersContext };
